import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconFilter({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M9 10.411V16.1507L11 17.3507V10.411L17.5 3.41097V2.5H2.5V3.41096L9 10.411ZM1 4V1H19V4L12.5 11V20L7.5 17V11L1
      4Z
    </Icon>
  );
}
